import React, {SVGProps} from "react";
import OfflineArticle from "./articles/internet_wifi/OfflineArticle.tsx";
import WifiForventningerArticle from "./articles/internet_wifi/WifiForventningerArticle.tsx";
import UnstableArticle from "./articles/internet_wifi/UnstableArticle.tsx";
import InternetAndWifiArticle from "./articles/internet_wifi/InternetAndWifiArticle.tsx";
import WifiFindNavnKodeArticle from "./articles/internet_wifi/WifiFindNavnKodeArticle.tsx";
import WifiSkiftNavnKodeArticle from "./articles/internet_wifi/WifiSkiftNavnKodeArticle.tsx";
import WifiFrekvenserArticle from "./articles/internet_wifi/WifiFrekvenserArticle.tsx";
import NetvaerksKanalArticle from "./articles/internet_wifi/NetvaerksKanalArticle.tsx";
import SpeedTestArticle from "./articles/internet_wifi/SpeedTestArticle.tsx";
import HvordanTraekkerJeg1000Article from "./articles/internet_wifi/HvordanTraekkerJeg1000Article.tsx";
import RouterPlaceringArticle from "./articles/internet_wifi/RouterPlaceringArticle.tsx";
import DataConsumptionArticle from "./articles/internet_wifi/DataConsumptionArticle.tsx";
import IPAddressArticle from "./articles/internet_wifi/IPAddressArticle.tsx";
import VpnAndSubnetArticle from "./articles/internet_wifi/VpnAndSubnetArticle.tsx";
import CompareInternetArticle from "./articles/internet_wifi/CompareInternetArticle.tsx";
import SpeedAndDuplexArticle from "./articles/internet_wifi/SpeedAndDuplexArticle.tsx";
import UnitsOnWifiArticle from "./articles/internet_wifi/UnitsOnWifiArticle.tsx";
import RouterConsumptionArticle from "./articles/udstyr/RouterConsumptionArticle.tsx";
import EgenRouterArticle from "./articles/udstyr/EgenRouterArticle.tsx";
import InstallationManualArticle from "./articles/udstyr/InstallationManualArticle.tsx";
import HvilkenRouterArticle from "./articles/udstyr/HvilkenRouterArticle.tsx";
import BridgeModeArticle from "./articles/udstyr/BridgeModeArticle.tsx";
import VLANTaggingArticle from "./articles/udstyr/VLANTaggingArticle.tsx";
import PortForwardArticle from "./articles/udstyr/PortForwardArticle.tsx";
import TilslutEkstraudstyrArticle from "./articles/udstyr/TilslutEkstraudstyrArticle.tsx";
import ForstaaRegningArticle from "./articles/regning_betaling/ForstaaRegningArticle.tsx";
import BetalingsMulighederArticle from "./articles/regning_betaling/BetalingsMulighederArticle.tsx";
import FirmaBetaltArticle from "./articles/regning_betaling/FirmaBetaltArticle.tsx";
import MistetKortArticle from "./articles/regning_betaling/MistetKortArticle.tsx";
import BetalingAfvistArticle from "./articles/regning_betaling/BetalingAfvistArticle.tsx";
import SbbuArticle from "./articles/bestilling/SbbuArticle.tsx";
import KanJegFaa1000MbitArticle from "./articles/bestilling/KanJegFaa1000MbitArticle.tsx";
import LeveringsTidArticle from "./articles/bestilling/LeveringsTidArticle.tsx";
import NyOnlineDatoArticle from "./articles/bestilling/NyOnlineDatoArticle.tsx";
import NyTeknikerTidArticle from "./articles/bestilling/NyTeknikerTidArticle.tsx";
import MitHiperArticle from "./articles/abonnement/MitHiperArticle.tsx";
import BindingsPeriodeArticle from "./articles/abonnement/BindingsPeriodeArticle.tsx";
import FortrydelsesretArticle from "./articles/abonnement/FortrydelsesretArticle.tsx";
import OpsigelseArticle from "./articles/abonnement/OpsigelseArticle.tsx";
import UdstyrReturArticle from "./articles/abonnement/UdstyrReturArticle.tsx";
import GravningArticle from "./articles/abonnement/GravningArticle.tsx";
import FlytningArticle from "./articles/abonnement/FlytningArticle.tsx";
import OverdragTilAndenPersonArticle from "./articles/abonnement/OverdragTilAndenPersonArticle.tsx";
import SkiftHastighedArticle from "./articles/abonnement/SkiftHastighedArticle.tsx";
import FiberInstallationArticle from "./articles/bestilling/FiberInstallationArticle.tsx";
import TeknikerCoaxArticle from "./articles/bestilling/TeknikerCoaxArticle.tsx";
import SommerhusArticle from "./articles/bestilling/SommerhusArticle.tsx";
import GamingArticle from "./articles/bestilling/GamingArticle.tsx";
import IconProduct from "../../components/icons/IconProduct.tsx";
import IconWifi from "../../components/icons/IconWifi.tsx";
import IconUser from "../../components/icons/IconUser.tsx";
import IconCreditcard from "../../components/icons/IconCreditcard.tsx";
import IconRouterSmall from "../../components/icons/IconRouterSmall.tsx";

export type Article = {
    art_name: string;
    heading: string;
    link: string;
    meta_title: string;
    meta_desc: string;
    content: (() => React.JSX.Element)
}

export type Category = {
    cat_name: string;
    summary: string;
    link: string;
    slug: string;
    icon: ((props: SVGProps<SVGSVGElement>) => React.JSX.Element)
    meta_title: string;
    meta_desc: string;
    articles: { [key: string]: Article }
};

export const Categories: { [key: string]: Category } = {
    "bestilling": {
        "cat_name": "Bestilling",
        "summary": "Få hjælp til din bestilling og find svar på ofte stillede spørgsmål.",
        "link": "bestilling",
        "slug": "bestilling",
        "icon": IconProduct,
        "meta_title": "Få hjælp til din bestilling af bredbånd",
        "meta_desc": "Få hjælp til din bestilling og find svar på ofte stillede spørgsmål, så du kan få lynhurtigt internet hurtigst muligt.",
        "articles": {
            "opsig-eksisterende-abonnement": {
                "art_name": "Skal jeg selv opsige mit eksisterende abonnement?",
                "heading": "Skal jeg selv opsige mit eksisterende abonnement?",
                "link": "opsig-eksisterende-abonnement",
                "meta_title": "Opsig eksisterende abonnement",
                "meta_desc": "Vi hjælper dig med at opsige dit nuværende abonnement, hvis du bestiller fibernet eller internet via kabel-tv-stikket.",
                content: SbbuArticle
            },
            "kan-jeg-faa-1000-mbit": {
                "art_name": "Kan jeg få 1.000 Mbit?",
                "heading": "Kan jeg få 1.000 Mbit?",
                "link": "kan-jeg-faa-1000-mbit",
                "meta_title": "Sådan får du 1.000 Mbit internet",
                "meta_desc": "Vil du også gerne have 1.000 Mbit? Det kræver bredbånd via fiber eller tv-kabel. Vi leverer internet med lynhurtige hastigheder til knivskarpe priser.",
                content: KanJegFaa1000MbitArticle
            },
            "leveringstid": {
                "art_name": "Hvad er leveringstiden på internet?",
                "heading": "Hvad er leveringstiden på internet?",
                "link": "leveringstid",
                "meta_title": "Så hurtigt kan du få leveret dit internet",
                "meta_desc": "Vores leveringstid afhænger af, hvilken teknologi samt netværk du skal have internet igennem. Kontakt os for at få mere at vide.",
                content: LeveringsTidArticle
            },
            "fiber-installation": {
                "art_name": "Alt om fibernet-installation",
                "heading": "Alt om fibernet-installation",
                "link": "fiber-installation",
                "meta_title": "Sådan får du installeret fiber",
                "meta_desc": "Læs her hvordan du får installeret fiber.",
                content: FiberInstallationArticle
            },
            "tekniker-ved-kabel-tv-stik": {
                "art_name": "Teknikerbesøg ved kabel-tv-stik",
                "heading": "Teknikerbesøg ved kabel-tv-stik",
                "link": "tekniker-ved-kabel-tv-stik",
                "meta_title": "Teknikerbesøg ved bredbånd via kabel-tv-stik",
                "meta_desc": "Når du bestiller 1.000 Mbit via kabel-tv stikket, skal dit stik på adressen være opdateret med stikket DOCSIS 3.1. Ellers kræver det teknikerbesøg.",
                content: TeknikerCoaxArticle
            },
            "internet-til-gaming": {
                "art_name": "Internet til gaming",
                "heading": "Internet til gaming",
                "link": "internet-til-gaming",
                "meta_title": "Internet til gaming | Ingen lag med 1000 Mbit lynhurtigt internet",
                "meta_desc": "Skal du have det bedste internet og wifi til gaming, kan du finde det hos Hiper. Lynhurtige hastigheder og priser fra 99,-/md.",
                content: GamingArticle
            },
            "ny-online-dato": {
                "art_name": "Ønsker du at ændre datoen for, hvornår dit internet er klar?",
                "heading": "Ønsker du at ændre datoen for, hvornår dit internet er klar?",
                "link": "ny-online-dato",
                "meta_title": "Hjælp til at ændre startdato for internet",
                "meta_desc": "Har du brug for at rykke datoen for, hvornår dit internet fra Hiper er klar? Det gør du enten ved at ringe til os via kundeservice eller chat.",
                content: NyOnlineDatoArticle
            },
            "ny-teknikertid": {
                "art_name": "Sådan ændrer du din teknikertid",
                "heading": "Sådan ændrer du din teknikertid",
                "link": "ny-teknikertid",
                "meta_title": "Sådan ændrer du din teknikertid",
                "meta_desc": "Har du brug for at rykke datoen for dit teknikerbesøg? Så få hjælp til at gøre det her, hvis du kontakter os senest 48 timer før besøget.",
                content: NyTeknikerTidArticle
            },
            "internet-i-sommerhus": {
                "art_name": "Internet i sommerhus",
                "heading": "Internet i sommerhus",
                "link": "internet-i-sommerhus",
                "meta_title": "Få 5G-internet eller fiber til sommerhuset",
                "meta_desc": "Hos Hiper kan du få 5G-internet eller fiber til sommerhuset, alt efter ønske og muligheder. Få en stabil forbindelse, uanset hvor i landet du befinder dig.",
                content: SommerhusArticle
            }
        }
    },
    "internet-og-wifi": {
        "cat_name": "Internet og wifi",
        "summary": "Få hjælp til at optimere dit internet og wifi.",
        "link": "internet-og-wifi",
        "slug": "internet_wifi",
        "icon": IconWifi,
        "meta_title": "Få hjælp til at optimere dit internet og wifi",
        "meta_desc": "Vi har samlet et overblik over, hvordan du bl.a. skifter navn og kode på dit wifi, og hvad du kan gøre, hvis dit internet ikke virker.",
        "articles": {
            "offline": {
                "art_name": "Mit internet virker ikke",
                "heading": "Mit internet virker ikke",
                "link": "offline",
                "meta_title": "Mit internet virker ikke",
                "meta_desc": "Følg vores guide til hvad du kan gøre, hvis dit internet ikke virker. Hvis det ikke hjælper, så kontakt vores kundeservice.",
                "content": OfflineArticle,
            },
            "ustabilt-internet": {
                "art_name": "Ustabilt internet",
                "heading": "Ustabilt internet",
                "link": "ustabilt-internet",
                "meta_title": "Ustabilt internet",
                "meta_desc": "Er dit bredbånd ustabilt? Få hjælp her til hvordan du får styr på din forbindelse, så det ikke hakker, er langsomt eller hopper af.",
                content: UnstableArticle
            },
            "info-om-internet-og-wifi": {
                "art_name": "Godt at vide om wifi og internet",
                "heading": "Godt at vide om wifi og internet",
                "link": "info-om-internet-og-wifi",
                "meta_title": "Wifi og internet | Kend forskellen",
                "meta_desc": "Læs med her, hvis du gerne vil blive lidt klogere på, hvad wifi og internet er samt hvad der adskiller dem.",
                content: InternetAndWifiArticle
            },
            "navn-og-kode-til-wifi": {
                "art_name": "Hvor ser jeg mit navn og kode til wifi?",
                "heading": "Hvor ser jeg mit navn og kode til wifi?",
                "link": "navn-og-kode-til-wifi",
                "meta_title": "Navn og kode til wifi",
                "meta_desc": "Kender du ikke navn og kode til dit wifi? Eller måske har du glemt din wifi-kode? Vi guider til, hvordan du finder frem til navn og kode til dit wifi.",
                content: WifiFindNavnKodeArticle
            },
            "skift-navn-og-kode-paa-wifi": {
                "art_name": "Skift navn og kode på wifi",
                "heading": "Skift navn og kode på wifi",
                "link": "skift-navn-og-kode-paa-wifi",
                "meta_title": "Skift navn og kode på wifi",
                "meta_desc": "Hvis du ønsker at ændre dit navn og kodeord på dit wifi, så hjælper vi dig gerne med det. Brug følgende guide &ndash; det er nemt og hurtigt!",
                content: WifiSkiftNavnKodeArticle
            },
            "forventninger-til-wifi": {
                "art_name": "Hvad kan jeg forvente af mit wifi?",
                "heading": "Hvad kan jeg forvente af mit wifi?",
                "link": "forventninger-til-wifi",
                "meta_title": "Din forventning til wifi rækkevidde",
                "meta_desc": "Mange faktorer er afgørende for, hvilken hastighed du får på din forbindelse. Bliv klogere på, hvad du kan forvente af din wifi-forbindelse derhjemme.",
                content: WifiForventningerArticle
            },
            "forskel-paa-signal-frekvenser": {
                "art_name": "Forskellen på 2,4 GHz og 5 GHz",
                "heading": "Forskellen på 2,4 GHz og 5 GHz",
                "link": "forskel-paa-signal-frekvenser",
                "meta_title": "Forskellen på 2,4 GHz og 5 GHz til din wifi",
                "meta_desc": "Forskellen på 2,4 GHz og 5 GHz.",
                content: WifiFrekvenserArticle
            },
            "netvaerkskanaler": {
                "art_name": "Netværkskanaler",
                "heading": "Netværkskanaler",
                "link": "netvaerkskanaler",
                "meta_title": "Netværkskanaler",
                "meta_desc": "Bliv klogere på netværkskanaler",
                content: NetvaerksKanalArticle
            },
            "hastighedstest": {
                "art_name": "Hastighedstest - Test din internet-hastighed",
                "heading": "Hastighedstest",
                "link": "hastighedstest",
                "meta_title": "Sådan foretager du en hastighedstest",
                "meta_desc": "Med Hipers hastighedstest, kan du teste hvor hurtigt dit internet er. Få råd til hvordan du tager den, og hvad der påvirker din hastighed.",
                content: SpeedTestArticle
            },
            "hvordan-traekker-jeg-1000-mbit": {
                "art_name": "Hvordan trækker jeg 1.000 Mbit?",
                "heading": "Hvordan trækker jeg 1.000 Mbit?",
                "link": "hvordan-traekker-jeg-1000-mbit",
                "meta_title": "Sådan trækker du 1.000 Mbit",
                "meta_desc": "Læs her, hvad det kræver at trække 1.000 Mbit bredbånd hjemme hos dig. Med 1.000 Mbit sikrer du dig den gode internetoplevelse.",
                content: HvordanTraekkerJeg1000Article
            },
            "placering-af-router": {
                "art_name": "Hvor er det bedst at placere min router?",
                "heading": "Hvor er det bedst at placere min router?",
                "link": "placering-af-router",
                "meta_title": "Den bedste placering af din router",
                "meta_desc": "Læs om, hvor du skal placere din router for at få det bedste ud af din internetforbindelse. Der er mange ting i dit hjem, som kan påvirke dit wifi.",
                content: RouterPlaceringArticle
            },
            "dataforbrug": {
                "art_name": "Hvor meget data bruger jeg?",
                "heading": "Hvor meget data bruger jeg?",
                "link": "dataforbrug",
                "meta_title": "Hvor meget data bruger jeg?",
                "meta_desc": "Vores bredbåndsløsninger har ingen data begrænsninger, så du betaler for dit abonnement og den valgte hastighed og så bruger du alt den data du ønsker.",
                content: DataConsumptionArticle
            },
            "ip-adresse": {
                "art_name": "En guide til din IP-adresse",
                "heading": "En guide til din IP-adresse",
                "link": "ip-adresse",
                "meta_title": "En guide til din IP-adresse",
                "meta_desc": "Har du brug for en fast IP-adresse til din server eller har du problemer med din NAT type? Læs om vores IP-adresse produkter og hvordan de kan hjælpe.",
                content: IPAddressArticle
            },
            "vpn-og-subnet": {
                "art_name": "VPN og Subnet",
                "heading": "VPN og Subnet",
                "link": "vpn-og-subnet",
                "meta_title": "VPN og subnet i relation til dit internet",
                "meta_desc": "Internettet er lidt mere komplekst end som så, så bliv klogere på brugen af VPN og hvad subnet- mask og calculator betyder.",
                content: VpnAndSubnetArticle
            },
            "hvilket-internet-skal-jeg-vaelge": {
                "art_name": "Hvilket internet skal jeg vælge?",
                "heading": "Hvilket internet skal jeg vælge?",
                "link": "hvilket-internet-skal-jeg-vaelge",
                "meta_title": "Hvilket internet skal jeg vælge? 5G, fiber eller coax",
                "meta_desc": "Sammenlign de forskellige internetforbindelser og tjek hvilken forbindelse, som matcher dine behov. Hos Hiper har vi internet via 5G, fiber og coax.",
                content: CompareInternetArticle
            },
            "netvaerkskort": {
                "art_name": "Indstil dit netværkskort til at understøtte 1000 Mbit",
                "heading": "Indstil dit netværkskort til at understøtte 1000 Mbit",
                "link": "netvaerkskort",
                "meta_title": "Indstil dit netværkskort til at understøtte 1000 Mbit",
                "meta_desc": "Sådan får du dit netværkskort til at understøtte 1000 Mbit",
                content: SpeedAndDuplexArticle
            },
            "enheder-paa-wifi": {
                "art_name": "Hvor mange enheder er på mit wifi?",
                "heading": "Hvor mange enheder er på mit wifi?",
                "link": "enheder-paa-wifi",
                "meta_title": "Se hvilke enheder, der bruger dit wifi",
                "meta_desc": "Sådan ser du hvilke enheder, der bruger dit wifi",
                content: UnitsOnWifiArticle
            }/*,
            "internethastigheder-og-datamaengder": {
                "art_name": "Hvor mange enheder er på mit wifi?",
                "heading": "Hvor mange enheder er på mit wifi?",
                "link": "internethastigheder-og-datamaengder",
                "meta_title": "Se hvilke enheder, der bruger dit wifi",
                "meta_desc": "Sådan ser du hvilke enheder, der bruger dit wifi",
                content: DataSpeedsAndAmounts
            }*/
        }
    },
    "mit-abonnement": {
        "cat_name": "Mit abonnement",
        "summary": "Få overblik over dit abonnement og meget mere.",
        "link": "mit-abonnement",
        "slug": "abonnement",
        "icon": IconUser,
        "meta_title": "Overblik over dit abonnement",
        "meta_desc": "Hos Hiper er det nemt og enkelt at være kunde, da vi har lavet et samlet overblik over dit abonnement under Mit Hiper.",
        "articles": {
            "mit-hiper": {
                "art_name": "Mit Hiper",
                "heading": "Mit Hiper",
                "link": "mit-hiper",
                "meta_title": "Overblik over Mit Hiper",
                "meta_desc": "Når du bliver kunde hos Hiper, får du adgang til Mit Hiper, som er dit helt eget personlige selvbetjeningsunivers. Få overblik over Mit Hiper nu.",
                content: MitHiperArticle
            },
            "bindingsperiode": {
                "art_name": "Hvor lang er min bindingsperiode?",
                "heading": "Hvor lang er min bindingsperiode?",
                "link": "bindingsperiode",
                "meta_title": "Så lang er din bindingsperiode",
                "meta_desc": "Hos Hiper har du 6 måneders binding, gældende fra leveringsdatoen. Køb lynhurtigt internet allerede i dag.",
                content: BindingsPeriodeArticle
            },
            "fortrydelsesret": {
                "art_name": "Hvor lang fortrydelsesret har jeg?",
                "heading": "Hvor lang fortrydelsesret har jeg?",
                "link": "fortrydelsesret",
                "meta_title": "Din fortrydelsesret",
                "meta_desc": "Fortryder du købet af dit bredbånd? Du har 14 dages fortrydelsesret fra den dag, du modtog din ordrebekræftelse. Brug formularen eller ring til os.",
                content: FortrydelsesretArticle
            },
            "opsigelse": {
                "art_name": "Hvordan opsiger jeg mit abonnement?",
                "heading": "Hvordan opsiger jeg mit abonnement?",
                "link": "opsigelse",
                "meta_title": "Opsigelse af bredbåndsabonnement",
                "meta_desc": "Hvis du ønsker at opsige eller skifte dit Hiper bredbåndsabonnement, kan du få hjælp her.",
                content: OpsigelseArticle
            },
            "returner-udstyr": {
                "art_name": "Hvordan returnerer jeg mit udstyr?",
                "heading": "Hvordan returnerer jeg mit udstyr?",
                "link": "returner-udstyr",
                "meta_title": "Sådan returnerer du dit udstyr",
                "meta_desc": "Har du en router, som du skal sende retur til Hiper? Vi hjælper dig med, hvilket udstyr vi skal have retur samt hvordan du returnerer det.",
                content: UdstyrReturArticle
            },
            "gravning": {
                "art_name": "Gode råd, inden du graver og bygger om",
                "heading": "Gode råd, inden du graver og bygger om",
                "link": "gravning",
                "meta_title": "Gode råd inden du graver og bygger om i haven",
                "meta_desc": "Skal du til at renovere din have og vil sikre dig, at du ikke graver dine kabler over i jorden? Hiper har samlet en masse gode råd til dette.",
                content: GravningArticle
            },
            "skal-du-flytte": {
                "art_name": "Skal du flytte dit abonnement til en anden adresse?",
                "heading": "Skal du flytte dit abonnement til en anden adresse?",
                "link": "skal-du-flytte",
                "meta_title": "Flyt dit internet",
                "meta_desc": "Hvis du skal flytte og vil tage dit internet med, så skal du sende en mail til vores kundeservice. Læs her, hvad du skal inkludere i din mail.",
                content: FlytningArticle
            },
            "overdrag-dit-internet-til-anden-person": {
                "art_name": "Overdrag dit internet til en anden person",
                "heading": "Overdrag dit internet til en anden person",
                "link": "overdrag-dit-internet-til-anden-person",
                "meta_title": "Overdrag internet til en anden person",
                "meta_desc": "Kontakt os gerne hurtigst muligt, når du skal overdrage dit abonnement til en anden person &ndash; det kan nemlig tage lidt tid.",
                content: OverdragTilAndenPersonArticle
            },
            "skift-hastighed": {
                "art_name": "Skift din hastighed",
                "heading": "Skift din hastighed",
                "link": "skift-hastighed",
                "meta_title": "Skift din hastighed",
                "meta_desc": "Vi skifter din hastighed helt uden problemer og uden at du behøver en ny router - det er nemt og gratis.",
                content: SkiftHastighedArticle
            }
        }
    },
    "regning-og-betaling": {
        "cat_name": "Regning og betaling",
        "summary": "Få hjælp til at forstå din regning og hvordan du kan betale dit abonnement.",
        "link": "regning-og-betaling",
        "slug": "regning_betaling",
        "icon": IconCreditcard,
        "meta_title": "Regning og betaling af bredbånd",
        "meta_desc": "Vi hjælper dig med at forstå din regning og giver dig et overblik over betalingsmuligheder. Vores hjælpeunivers kan hjælpe dig godt på vej.",
        "articles": {
            "forstaa-din-regning": {
                "art_name": "Forstå din regning",
                "heading": "Forstå din regning",
                "link": "forstaa-din-regning",
                "meta_title": "Forstå din regning",
                "meta_desc": "Kan du ikke forstå din regning? Vi hjælper dig med at forstå, hvad din regning indeholder og hvad du præcis betaler for.",
                content: ForstaaRegningArticle
            },
            "betalingsmuligheder": {
                "art_name": "Hvordan kan jeg betale min regning?",
                "heading": "Hvordan kan jeg betale min regning?",
                "link": "betalingsmuligheder",
                "meta_title": "Betalingsmuligheder for dit internet",
                "meta_desc": "Er du i tvivl om, hvordan du betaler din første regning? Vi har lavet en guide, som forklarer skift af betalingskort samt betalingsmuligheder.",
                content: BetalingsMulighederArticle
            },
            "internet-betalt-af-arbejdsgiver": {
                "art_name": "Min arbejdsgiver skal betale for mit internet",
                "heading": "Min arbejdsgiver skal betale for mit internet",
                "link": "internet-betalt-af-arbejdsgiver",
                "meta_title": "Internet betalt af arbejdsgiver",
                "meta_desc": "Din arbejdsgiver kan godt betale for dit internet, så længe der er et betalingskort tilkoblet. Læs om alt ved arbejdsgiverbetalt internet i vores guide.",
                content: FirmaBetaltArticle
            },
            "mistet-kort": {
                "art_name": "Jeg har mistet mit betalingskort",
                "heading": "Jeg har mistet mit betalingskort",
                "link": "mistet-kort",
                "meta_title": "Jeg har mistet mit betalingskort",
                "meta_desc": "Hvis du mister dit kort, skal du kontakte os hurtigst muligt. Så sikrer vi os, at din regning bliver udskudt og at du undgår rykkere.",
                content: MistetKortArticle
            },
            "betaling-afvist": {
                "art_name": "Min betaling er afvist",
                "heading": "Min betaling er afvist",
                "link": "betaling-afvist",
                "meta_title": "Min betaling er afvist",
                "meta_desc": "Vi har samlet de hyppigste betalingsafvisninger og hvad du skal gøre i tilfælde af, at regningen ikke kan trækkes.",
                content: BetalingAfvistArticle
            }
        }
    },
    "udstyr": {
        "cat_name": "Udstyr",
        "summary": "Find hjælp til at bruge det udstyr, du har modtaget fra os.",
        "link": "udstyr",
        "slug": "udstyr",
        "icon": IconRouterSmall,
        "meta_title": "Hjælp til brug af bredbåndsudstyr",
        "meta_desc": "Hos Hiper har vi samlet et overblik af guides til f.eks. installation af router, hvilken router der følger med dit abonnement og brug af eget udstyr.",
        "articles": {
            "hvor-meget-stroem-bruger-en-router": {
                "art_name": "Hvor meget strøm bruger en router?",
                "heading": "Hvor meget strøm bruger en router?",
                "link": "hvor-meget-stroem-bruger-en-router",
                "meta_title": "Så meget strøm bruger din router",
                "meta_desc": "Din router bruger generelt strøm til at holde basis-systemet oppe for at være &ldquo;klar&rdquo; til internettrafik hele tiden. Læs mere om det her.",
                content: RouterConsumptionArticle
            },
            "kan-jeg-bruge-mit-eget-udstyr": {
                "art_name": "Kan jeg bruge mit eget udstyr?",
                "heading": "Kan jeg bruge mit eget udstyr?",
                "link": "kan-jeg-bruge-mit-eget-udstyr",
                "meta_title": "Brug af eget router udstyr",
                "meta_desc": "Hos Hiper får du en gratis lånerouter. Hvis du hellere vil bruge dit eget udstyr, så guider vi dig til, hvordan du sætter din egen router til.",
                content: EgenRouterArticle
            },
            "installationsmanual": {
                "art_name": "Sådan installerer du dit udstyr",
                "heading": "Sådan installerer du dit udstyr",
                "link": "installationsmanual",
                "meta_title": "Sådan installerer du din router",
                "meta_desc": "Skal du have hjælp til router opsætning? Download vores installationsmanual og så guider vi dig med installationen og aktiveringen af din forbindelse.",
                content: InstallationManualArticle
            },
            "hvilken-router-foelger-med": {
                "art_name": "Hvilken router følger med?",
                "heading": "Hvilken router følger med?",
                "link": "hvilken-router-foelger-med",
                "meta_title": "Router til dit Hiper bredbånd",
                "meta_desc": "Når du køber internet hos Hiper, så låner du en standard router, som dækker de flestes behov. Typen af router afhænger af hvilken forbindelse du har.",
                content: HvilkenRouterArticle
            },
            "bridge-mode": {
                "art_name": "Guide til Bridge Mode",
                "heading": "Guide til Bridge Mode",
                "link": "bridge-mode",
                "meta_title": "Guide til bridge mode på din router",
                "meta_desc": "Hvis du ønsker at bruge din egen router, kan du sætte vores router i bridge mode.",
                content: BridgeModeArticle
            },
            "vlan-tagging": {
                "art_name": "Guide til VLAN-tagging",
                "heading": "Guide til VLAN-tagging",
                "link": "vlan-tagging",
                "meta_title": "Brug din egen router ved hjælp af VLAN-tagging",
                "meta_desc": "Har du købt internet hos Hiper og vil gerne bruge din egen router? Læs med her, om hvordan den konfigureres til at kommunikere med vores netværk.",
                content: VLANTaggingArticle
            },
            "port-forward": {
                "art_name": "Guide til Port Forward",
                "heading": "Guide til Port Forward",
                "link": "port-forward",
                "meta_title": "Guide til Port Forward",
                "meta_desc": "Læs alt om, hvordan du opsætter port forward via router til fiber, kabel eller telefonstik lige her. Vi har guides, der vejleder dig.",
                content: PortForwardArticle
            },
            "tilslut-ekstraudstyr": {
                "art_name": "Hvordan tilslutter jeg ekstraudstyr?",
                "heading": "Hvordan tilslutter jeg ekstraudstyr?",
                "link": "tilslut-ekstraudstyr",
                "meta_title": "Tilslut ekstraudstyr",
                "meta_desc": "Det er super nemt at bruge ekstraudstyr med din Hiper-router!",
                content: TilslutEkstraudstyrArticle
            }
        }
    }
}

export function GetCategory(query: string): false|Category {
    if (!(query in Categories)) {
        return false
    }
    
    return Categories[query]
}

export function GetCategoryArticle(category: Category, query: string): false|Article {
    if (!(query in category.articles)) {
        return false
    }

    return category.articles[query]
}
